import React, { useEffect, useState } from 'react';

import CommonService from '../../../services/commonService';
import MainTabsBodyMyAccount from '../MainTabsBodyMyAccount/MainTabsBodyMyAccount';
import MainTabsBodyMyPromotions from '../MainTabsBodyMyPromotions/MainTabsBodyMyPromotions';
import MainTabsBodyMyTransactions from '../MainTabsBodyMyTransactions/MainTabsBodyMyTransactions';
import MainTabsBodyMyTrips from '../MainTabsBodyMyTrips/MainTabsBodyMyTrips';
import MainTabsMenu from '../MainTabsMenu/MainTabsMenu';
import MainTabsBodyCuponera from '../MainTabsBodyCuponera/MainTabsBodyCuponera';

function MainTabContainer(props) {
  const [menus, setMenus] = useState([
    {
      icon: '/svgs/my-account/my-account-orange.svg',
      iconActive: '/svgs/my-account/my-account-grey.svg',
      name: 'MY_ACCOUNT',
      active: true,
    },
    // {
    //   icon: '/svgs/my-account/cuponera.svg',
    //   iconActive: '/svgs/my-account/cuponera-grey.svg',
    //   name: 'CUPONERA',
    //   active: false,
    // },
    {
      icon: '/svgs/my-account/my-trips-orange.svg',
      iconActive: '/svgs/my-account/my-trips-grey.svg',
      name: 'MY_TRIPS',
      active: false,
    },
    {
      icon: '/svgs/my-account/my-movements-orange.svg',
      iconActive: '/svgs/my-account/my-movements-grey.svg',
      name: 'MY_MOVEMENTS',
      active: false,
    },
    {
      icon: '/svgs/my-account/promotions-orange.svg',
      iconActive: '/svgs/my-account/promotions-grey.svg',
      name: 'PROMOTIONS',
      active: false,
    },
  ]);

  const [classOfSubBody, setClassOfSubBody] = useState('null');

  // COMPONENT DID MOUNT
  useEffect(() => {
    switch (props.params.tabName) {
      case 'trips':
        onMenuChange(1);
        break;
      case 'transactions':
        onMenuChange(2);
        break;
      case 'groups':
        onMenuChange(3);
        break;
      case 'promotions':
        onMenuChange(4);
        break;
      default:
        onMenuChange(0);
        break;
    }
  }, []);

  // COMPONENT DID UPDATE
  // useEffect(() => {
  //   switch (props.params.tabName) {
  //     case 'trips':
  //       onMenuChange(1);
  //       break;
  //     case 'transactions':
  //       onMenuChange(2);
  //       break;
  //     case 'groups':
  //       onMenuChange(3);
  //       break;
  //     case 'promotions':
  //       onMenuChange(4);
  //       break;
  //     default:
  //       onMenuChange(0);
  //       break;
  //   }
  // }, [props.params.tabName]);

  const onMenuChange = i => {
    props.onParentMenusChange('LEFT_MENU');

    console.log({ i });
    console.log('props.params.tabName', props.params.tabName);

    let menusTemp = CommonService.copyObject(menus);
    for (let m of menusTemp) {
      m.active = false;
    }
    menusTemp[i].active = true;
    // this.setState({ menus: menus });
    setMenus(menusTemp);
  };

  // function to render the Tabs Body Item when the tab changes
  const renderBodyComponent = () => {
    let i;
    menus.map((val, k) => {
      if (props.menuType && props.menuType == 'LEFT_MENU' && val.active) {
        i = k;
      }
    });

    switch (i) {
      case 0:
        return (
          <MainTabsBodyMyAccount
            history={props.history}
            t={props.t}
            onMenuChange={onMenuChange}
            actions={props.actions}
            data={props.data}
            metaData={props.metaData}
          />
        );

      // case 1:
      //   return (
      //     <MainTabsBodyCuponera
      //       history={props.history}
      //       t={props.t}
      //       onMenuChange={onMenuChange}
      //       actions={props.actions}
      //       data={props.data}
      //       metaData={props.metaData}
      //     />
      //   );
      case 1:
        return (
          <MainTabsBodyMyTrips
            history={props.history}
            t={props.t}
            actions={props.actions}
            data={props.data}
            metaData={props.metaData}
          />
        );
      case 2:
        return (
          <MainTabsBodyMyTransactions
            onTopIconChange={props.onTopIconChange}
            t={props.t}
            actions={props.actions}
            data={props.data}
            onMenuChange={() => onMenuChange(0)}
          />
        );

      case 3:
        return (
          <MainTabsBodyMyPromotions
            t={props.t}
            actions={props.actions}
            data={props.data}
            onMenuChange={() => onMenuChange(0)}
          />
        );
      default:
        return;
    }
  };

  const { t } = props;

  console.log('Props in main tab container ---------', props);
  return (
    <div
      id="sub-details-section-my-account"
      className={
        'sub-details-section content-container  ' +
        (props.menuType && props.menuType == 'LEFT_MENU' ? 'kupos-card' : '')
      }
    >
      <MainTabsMenu menuType={props.menuType} t={t} menus={menus} onMenuChange={onMenuChange} />

      <div className="my-acc-tab-content-container">{props.metaData && renderBodyComponent()}</div>
    </div>
  );
}

export default MainTabContainer;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabContainer/MainTabContainer.js